import React, { useEffect, useState } from 'react';
import '../connectwithus/connectwithus.css';
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa6';
import { IoMdMail } from "react-icons/io";
import { FaArrowRightLong } from 'react-icons/fa6';
import mobimagetbilsi from '../../images/tbilisi2.webp';
import { ReactComponent as SuccesSVG } from '../../images/submittedimg.svg';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';
import { data_url } from '../../constants/data';

function Connectwithus() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    source: '',
    budget: '',
    description: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[\w.-]+@[\w.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }
    if (!formData.source.trim()) newErrors.source = 'Source is required';
    if (!formData.budget) newErrors.budget = 'Please select a budget';
    if (!formData.description.trim()) newErrors.description = 'Description is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      axios.post(`${data_url}/api/send-budget-email`, formData).then(() => {
        setIsSubmitted(true);

        setFormData({
          name: '',
          email: '',
          source: '',
          budget: '',
          description: ''
        })

        setTimeout(() => {
          setIsSubmitted(false)
        }, 3000)
      })
      .catch((e) => console.error(e))
    } else {
      setIsSubmitted(false);
    }
  };

  return (
    <section className='connectwithuss' data-aos='fade-up'>
      <div className="A-title" data-aos="fade-up" >
        <span>Connect with us</span>
        <h1>Let's dive into your project!</h1>
        <p className='title-text'>We are truly passionate about your project! Let's dive deep into the details together, exploring every phase and collaborating to bring your vision to life with unwavering dedication!</p>
      </div>
      <div className="connectwithus-main">
        <div className="cwus-left" data-aos="fade-up-left">
          <img className="mob-tbilisi" src={mobimagetbilsi} alt="Tbilisi" />
          <div className="cwusleft-inner">
            <h2 className='title'>Tbilisi</h2>
            <p className='adress'>I.Chavchavadze Ave. 37m, Tbilisi, Georgia</p>
            <ul className="social">
             <a href="https://www.linkedin.com/company/arttteo/posts/?feedView=all"><li><FaLinkedinIn /></li></a>
              <a href="https://www.facebook.com/arttteosoftware"><li><FaFacebookF /></li></a>
              <div className="mail">
                <li>
                  <IoMdMail />
                </li>
                <a href="mailto:Quotes@arttteo.com">Quotes@arttteo.com</a>
              </div>
            </ul>
          </div>
        </div>
        <form action="" className="cwus-right" data-aos="fade-up-right" onSubmit={handleSubmit}>
          <div className="_input">
            <h4>Your name</h4>
            {errors.name && <p className="error-text">{errors.name}</p>}
            <input 
              type="text" 
              name="name" 
              placeholder='Enter full name' 
              value={formData.name} 
              onChange={handleChange} 
            />       
          </div>
          <div className="_input">
            <h4>Enter email</h4>
            {errors.email && <p className="error-text">{errors.email}</p>}
            <input 
              type="email" 
              name="email" 
              placeholder='Enter email' 
              value={formData.email} 
              onChange={handleChange} 
            />
          </div>
          <div className="_input">
            <h4>How did you find us?</h4>
            {errors.source && <p className="error-text">{errors.source}</p>}
            <input 
              type="text" 
              name="source" 
              placeholder='e.g. Google, social media' 
              value={formData.source} 
              onChange={handleChange} 
            />
          </div>
          <div className="selectbudget">
            <h4>Your desired budget</h4>
            {errors.budget && <p className="error-text">{errors.budget}</p>}
            <select 
              name="budget" 
              value={formData.budget} 
              onChange={handleChange}
            >
              <option value="">Select your budget</option>
              <option value="25000">Up to 25,000$</option>
              <option value="35000">Up to 35,000$</option>
              <option value="45000">Up to 45,000$</option>
              <option value="55000">Up to 55,000$</option>
              <option value="75000">Up to 75,000$</option>
            </select>
          </div>

          <div className="describtion">
            <h4>Your company needs</h4>
            {errors.description && <p className="error-text">{errors.description}</p>}
            <textarea 
              name="description" 
              placeholder='Describe your details' 
              value={formData.description} 
              onChange={handleChange}
            ></textarea>
            
          </div>

          <div className="sendmessagebtn-succestext">
            <button type="submit" className="estimation-button">
              <p>Let's dive in!</p>
              <div className="arrow-circle">
                <FaArrowRightLong />
              </div>
            </button>
            {isSubmitted && (
              <div className="succestext">
                <SuccesSVG />
                <p>Submitted</p>
              </div>
            )}
          </div>
        </form>
      </div>
    </section>
  );
}

export default Connectwithus;
